<template>
  <div class="base-paginator" v-if="totalPages > 0">
    <div class="d-flex align-center">
      <div class="page-text flex-grow-1">
          Записи {{pageText}}
      </div>
      <div class="page-item-per-page d-flex">
          <span class="page-text">Записей на стр.</span>
          <v-menu bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="button-items-per-page"
                text
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                {{ params.itemsPerPage }}
                <v-icon small>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, i) in itemsPerPageOptionsDefault"
                :key="i"
              >
                <v-list-item-title>
                  <v-btn text @click="setItemPerPage(item)">{{ item }}</v-btn>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
      </div>
      <div class="page-pages d-flex">
        <v-btn small class="button-items-per-page" icon
                @click="setPage(1)" :disabled="params.page === 1">
          <v-icon small>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn v-for="page in linksLeft"
               :key="page"
               :class="{active:page===params.page}"
               x-small
               class="button-link button-items-per-page"
               text
               @click="setPage(page)">
              {{page}}
        </v-btn>
        <v-menu
          v-if="linksCenter.length > 0"
          top
          allow-overflow
          max-height="300"
          >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              class="button-items-per-page"
              v-bind="attrs"
              v-on="on"
            >
              ...
            </v-btn>
          </template>
          <v-list>

            <v-list-item
              v-for="(item, i) in linksCenter"
              :key="i"
            >
              <v-list-item-title >
                <v-btn text @click="setPage(item)">{{ item }}</v-btn>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn v-for="page in linksRight"
               :key="page"
               x-small
               class="button-link button-items-per-page"
               :class="{active:page===params.page}"
               text
               @click="setPage(page)">
          {{page}}
        </v-btn>
        <v-btn small class="button-items-per-page" icon
               @click="setPage(totalPages)" :disabled="params.page === totalPages">
          <v-icon small>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<style>
.base-paginator {
  margin-top: 0;
  border-top: 1px solid #E0E5EB;
  padding: 12px;
  background: #ffffff;
}

.page-text {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0;
  color: rgba(102, 123, 153, 1);
}

.button-items-per-page {
  padding: 0!important;
  margin: 0!important;
  font-style: normal!important;
  font-weight: 600!important;
  font-size: 12px!important;
  line-height: 16px!important;
  height: auto!important;
  min-width:auto!important;
}

.button-items-per-page .v-btn-content {
  height: auto!important;
  min-width:auto!important;
}

.button-link {
  padding: 4px!important;
  border-radius: 3px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0;
  text-align: center;

}

.button-link.active {
  background: #E0E5EB;
  border-radius: 3px;
  padding: 4px 6px!important;
}
</style>

<script>
export default {
  name: 'BasePaginator',
  props: ['params'],
  data() {
    return {
      itemsPerPageOptionsDefault: this.params.itemsPerPageOptions || [20, 50, 100, 500, 1000, 1500],
      maxLinks: 5,
    };
  },
  computed: {
    pagesList() {
      const arr = [];
      for (let i = 1; i <= this.totalPages; i += 1) {
        arr.push(i);
      }
      return arr;
    },
    linksMiddle() {
      return Math.ceil(this.maxLinks / 2);
    },
    linksLeft() {
      const arr = [];
      if (this.totalPages <= this.maxLinks) {
        for (let i = 1; i <= this.totalPages; i += 1) {
          arr.push(i);
        }
      } else {
        for (let i = 1; i < this.linksMiddle; i += 1) {
          arr.push(i);
        }
      }

      return arr;
    },
    linksCenter() {
      const arr = [];
      if (this.totalPages > this.maxLinks) {
        for (let i = this.linksMiddle; i <= this.totalPages - this.linksMiddle; i += 1) {
          arr.push(i);
        }
      }

      return arr;
    },
    linksRight() {
      const arr = [];
      if (this.totalPages > this.maxLinks) {
        for (let i = this.totalPages; i > this.totalPages - this.linksMiddle; i -= 1) {
          arr.push(i);
        }
      }

      return arr.reverse();
    },
    totalPages() {
      return Math.ceil(this.params.totalRecords / this.perPage);
    },
    perPage() {
      return Math.abs(this.params.itemsPerPage);
    },
    offsetStart() {
      return this.perPage * (this.params.page - 1) + 1;
    },
    offsetFinish() {
      const offset = this.perPage * this.params.page;
      return offset > this.params.totalRecords ? this.params.totalRecords : offset;
    },
    pageText() {
      return `${this.offsetStart} - ${this.offsetFinish} из ${this.params.totalRecords}`;
    },
  },
  methods: {
    changeParams() {
      this.$emit('change', this.params);
    },
    setItemPerPage(num) {
      this.params.itemsPerPage = num;
      this.changeItemPerPage();
    },
    setPage(page) {
      this.params.page = page;
      this.changeParams();
    },
    changeItemPerPage() {
      if (this.params.page > this.totalPages) {
        this.params.page = this.totalPages;
      }
      this.changeParams();
    },
    next() {
      this.params.page += 1;
      this.changeParams();
    },
    prev() {
      this.params.page -= 1;
      this.changeParams();
    },
  },
};
</script>

<style scoped>
  .pagination-per-page {
    width: 90px;
  }

  .page-text-label {
    font-size: 12px;
  }
  .page-text-content {
    font-size: 16px;
    color: #0b2e13;
  }
  .pagination-page-select {
    width: 190px;
  }
</style>
